import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from 'react-query';
import { BrowserRouter } from 'react-router-dom';
import { ChakraProvider } from '@chakra-ui/react';

import App from './App';
import { SettingsProvider } from './context/SettingsContext';

import './index.scss';

const queryClient = new QueryClient();

const rootElement = document.getElementById('root');
if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <ChakraProvider>
          <BrowserRouter>
            <SettingsProvider>
              <App />
            </SettingsProvider>
          </BrowserRouter>
        </ChakraProvider>
      </QueryClientProvider>
    </React.StrictMode>
  );
}
